import { render, staticRenderFns } from "./PathwayCohortViewStudentsList.vue?vue&type=template&id=91a53656&scoped=true&"
import script from "./PathwayCohortViewStudentsList.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortViewStudentsList.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCohortViewStudentsList.vue?vue&type=style&index=0&id=91a53656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a53656",
  null
  
)

export default component.exports